/**
 * Illustrations and annotations for the LOHP.
 */

import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {staticUrl} from "@repo/urls";

import {BackgroundBlob} from "#marketing-content-shared-package/background-blob.tsx";
import LastChanceCollage from "#marketing-content-shared-package/collages/last-chance.tsx";
import IllustrationContext from "#marketing-content-shared-package/illustration-context.ts";
import {MediaScrollButton} from "#marketing-content-shared-package/media-scroll-button.tsx";
import {SupportersBackground} from "#marketing-content-shared-package/supporters-background.tsx";

import FacesCollage from "./collages/faces.tsx";
import GraphCollage from "./collages/graph.tsx";

type Props = {
    children: React.ReactNode;
};

const PersonalizedLearningIcon = (): React.ReactElement<
    React.ComponentProps<"img">
> => (
    <img
        className={css(styles.icon)}
        src={staticUrl("/images/lohp/personalized_learning_icon.png")}
        alt=""
    />
);

const TrustedContentIcon = (): React.ReactElement<
    React.ComponentProps<"img">
> => (
    <img
        className={css(styles.contentIcon)}
        src={staticUrl("/images/lohp/trusted_content_icon.png")}
        alt=""
    />
);

const EmpowerTeachersIcon = (): React.ReactElement<
    React.ComponentProps<"img">
> => (
    <img
        className={css(styles.icon)}
        src={staticUrl("/images/lohp/empower_teachers_icon.png")}
        alt=""
    />
);

export default class Media extends React.Component<Props> {
    render(): React.ReactNode {
        const {children} = this.props;

        return (
            <IllustrationContext.Provider
                value={{
                    BackgroundBlob,
                    SupportersBackground,
                    GraphCollage: () => <GraphCollage />,
                    FacesCollage: () => <FacesCollage />,
                    LastChanceCollage,
                    PersonalizedLearningIcon,
                    TrustedContentIcon,
                    EmpowerTeachersIcon,
                    ScrollButton: MediaScrollButton,
                }}
            >
                {children}
            </IllustrationContext.Provider>
        );
    }
}

const styles = StyleSheet.create({
    icon: {
        width: "100%",
    },
    contentIcon: {
        width: "120%",
    },
});
